import {useMutation} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';

// endpoints start with "secure" so the api client does not add the api/v1 prefix
const SIGNUP_START = 'secure/auth/phone/signup/start';
const SIGNUP_VERIFY = 'secure/auth/phone/signup/verify';
const LOGIN_START = 'secure/auth/phone/login/start';
const LOGIN_VERIFY = 'secure/auth/phone/login/verify';

interface MessageResponse extends BackendResponse {
  message?: string;
}

// login start may either log the user in (bootstrapData) or ask for an OTP
export interface PhoneLoginStartResponse extends MessageResponse {
  bootstrapData?: string;
  two_factor?: boolean;
  otp_required?: boolean;
  must_reset_password?: boolean;
}

// matches the LoginResponse the SPA's success handler expects
export interface PhoneAuthSessionResponse extends BackendResponse {
  bootstrapData: string;
  two_factor: false;
}

export function useStartPhoneSignup() {
  return useMutation({
    mutationFn: (p: {phone: string; password: string; password_confirmation: string}) =>
      apiClient.post<MessageResponse>(SIGNUP_START, p).then(r => r.data),
  });
}

export function useVerifyPhoneSignup() {
  return useMutation({
    mutationFn: (p: {
      phone: string;
      code: string;
      password: string;
      password_confirmation: string;
      tracking_parameters?: Record<string, string>;
    }) => apiClient.post<PhoneAuthSessionResponse>(SIGNUP_VERIFY, p).then(r => r.data),
  });
}

export function useStartPhoneLogin() {
  return useMutation({
    mutationFn: (p: {phone: string; password: string}) =>
      apiClient.post<PhoneLoginStartResponse>(LOGIN_START, p).then(r => r.data),
  });
}

export function useVerifyPhoneLogin() {
  return useMutation({
    mutationFn: (p: {phone: string; password: string; code: string}) =>
      apiClient.post<PhoneAuthSessionResponse>(LOGIN_VERIFY, p).then(r => r.data),
  });
}
